import * as React from "react";
import { Box } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { ja } from "date-fns/locale";

type Props = {
  startDate: Date | null;
  endDate: Date | null;
  onStartChange: (date: Date | null) => void;
  onEndChange: (date: Date | null) => void;
  missionTarget?: boolean;
  onBlur?: () => void;
  startError?: boolean;
  endError?: boolean;
  startHelperText?: string;
  endHelperText?: string;
};

export const DateRangePicker: React.FC<Props> = ({
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  missionTarget,
  onBlur,
  startError,
  endError,
  startHelperText,
  endHelperText,
}) => {
  const viewsForMission = ["year", "month"] as const;
  const viewsDefault = ["year", "month", "day"] as const;
  const views = missionTarget ? viewsForMission : viewsDefault;
  const format = missionTarget ? "yyyy/MM" : undefined;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <Box display="flex" gap={2} alignItems={"flex-start"}>
        <DatePicker
          label={missionTarget ? "開始月" : "開始日"}
          value={startDate ?? null}
          views={views}
          format={format}
          onChange={onStartChange}
          slotProps={{
            textField: {
              size: "small",
              sx: {
                width: 177,
              },
              onBlur: onBlur,
              error: startError,
              helperText: startHelperText,
            },
          }}
        />
        <Box sx={{ marginTop: "10px" }}>～</Box>
        <DatePicker
          label={missionTarget ? "終了月" : "終了日"}
          value={endDate ?? null}
          views={views}
          format={format}
          onChange={onEndChange}
          minDate={startDate}
          slotProps={{
            textField: {
              size: "small",
              sx: {
                width: 177,
              },
              onBlur: onBlur,
              error: endError,
              helperText: endHelperText,
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};
